export default __webpack_public_path__ + "static/media/pkg3.4864e218.png";